import * as React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {UsersList} from "./UsersList";
import {VeboxDrawer} from "./components/VeboxDrawer";
import {UserListCount} from "./UserListCount";
import {AppTranslations} from "../components/Utils/translations/AppTranslations";

declare var AppTranslations: AppTranslations;


export const UserMenu: React.FC<any> = () => {

    const [open, setOpen] = React.useState<boolean>();

    const location = useLocation();
    const navigate = useNavigate();

    const toggle = () => {
        navigate("/");
    }

    const addNewUser = () => {
        navigate("/userCreation")
    }

    React.useEffect(() => {
        setOpen(location.pathname === "/");
    }, [location]);

    return (
        <VeboxDrawer
            className={"side-menu list-menu"}
            header={<h1>{AppTranslations.usersManagement.menu}</h1>}
            onToggle={toggle}
            open={open}
            closable={false}
        >
            <UserListCount addNewUser={addNewUser}/>
            <UsersList/>
        </VeboxDrawer>
    );
}
